import { Box, Center, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, useDisclosure, Spinner, ScaleFade, ModalHeader } from '@chakra-ui/react';
import React from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useCollection } from 'react-firebase-hooks/firestore';
import { useParams } from 'react-router-dom';
import { DataContext } from '../../../state/DataContext/DataContext';
import { firestore } from '../../../utils/firebase';
import AddTask from '../Task/AddTask/AddTask';
import ChecklistItem from './ChecklistItem/ChecklistItem';
import { Task } from '../../../typings/Job';

export default function Checklist() {

    const { tenantID, JobID } = useParams<any>();
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [task, setTask] = React.useState({} as Task);
    const { data, actions } = React.useContext(DataContext);

    const [value, loading, error] = useCollection(
        firestore.collection(`tenants/${tenantID}/jobs/${JobID}/tasks`)
            .where("Position", "!=", null)
            .orderBy("Position", "asc"),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );

    const moveTask = (currentDoc, targetDoc) => {
        actions.Task.MoveTask(tenantID, JobID, currentDoc, targetDoc)
    }

    const grid = 8;

    const getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        borderRadius: "0.25em", padding: "0.5em"
        ,
        // change background colour if dragging
        background: isDragging ? "#eee" : "white",

        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = isDraggingOver => ({
        background: isDraggingOver ? "#fff" : "#fff",
        marginTop: "0.1em",
        // padding: "0.1em 0.2em 0.5em 0.2em  ",
        // width: 250
    });
    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        let currentDoc = value!.docs[result.source.index].data();
        let targetDoc = value!.docs[result.destination.index].data();
        actions.Task.MoveTask(tenantID, JobID, currentDoc, targetDoc)
    }

    return (
        <div>
            {loading ? <Center><Spinner /></Center> :
                <ScaleFade hidden={loading} key="All-checklistitems" initialScale={0.9} in={!loading} >
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}
                                >
                                    <Box mt="4">
                                        {value && value?.docs.map((doc, index) => {
                                            let task = doc.data();
                                            return (
                                                <Draggable
                                                    key={task.TaskID}
                                                    draggableId={task.TaskID}
                                                    index={index}>
                                                    {(provided, snapshot) => {
                                                        return (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={getItemStyle(
                                                                    snapshot.isDragging,
                                                                    provided.draggableProps.style
                                                                )}
                                                            >
                                                                <ChecklistItem
                                                                    task={task}
                                                                    setTask={setTask}
                                                                    onOpen={onOpen}
                                                                    tenantID={tenantID}
                                                                    JobID={JobID}
                                                                    index={index}
                                                                    moveTask={moveTask}
                                                                    doc={doc}
                                                                    value={value}
                                                                />
                                                                {provided.placeholder}
                                                            </div>
                                                        )
                                                    }
                                                    }
                                                </Draggable>
                                            )
                                        })}
                                    </Box>
                                </div>
                            )
                            }
                        </Droppable>
                    </DragDropContext>
                </ScaleFade>
            }
            <Modal isCentered isOpen={isOpen} onClose={onClose} >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Edit Task</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <AddTask key="edit" isEdit onClosefn={onClose} Task={task} />
                    </ModalBody>
                </ModalContent>
            </Modal>

        </div >
    )
}
